import axios from "axios";
import { imvs_url } from "./host_data";

export const DeleteImv = async (nreg) => {
    const url = `${imvs_url}${nreg}/`
    const response = await axios.delete(`http://127.0.0.1:8000/faiimoveis_/imoveis/${nreg}/`, {
        headers: {
            'api-key': 'xUp2jAz5hQZM#wCsKb',
            'Content-Type': 'application/json'
        }
    })

    return response
}